// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const UserEditIcon = /* @__PURE__ */ createIcon(
  'user-edit',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M1.116 21c0-1.323-.011-2.206.215-2.951a5 5 0 0 1 3.334-3.334c.745-.226 1.629-.215 2.951-.215h1.5a1 1 0 1 1 0 2h-1.5c-1.468 0-1.98.01-2.37.129a3 3 0 0 0-2 2c-.12.39-.13.903-.13 2.371a1 1 0 1 1-2 0M18.16 10.043a2.768 2.768 0 1 1 3.914 3.914l-6.457 6.457c-.088.088-.203.207-.34.308q-.164.12-.35.205c-.154.07-.313.114-.434.148l-3.101.887a1 1 0 0 1-1.237-1.236l.887-3.102c.034-.12.077-.28.148-.434q.085-.186.206-.35c.1-.137.219-.252.307-.34zm2.5 1.414c-.3-.3-.786-.3-1.086 0l-6.457 6.457-.107.108c-.016.018-.012.014-.002.001.006-.014.007-.019 0 .003-.01.029-.02.068-.043.148l-.392 1.369 1.37-.39.148-.044.004-.002.108-.107 6.457-6.457c.3-.3.3-.786 0-1.086M13.616 7.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0m2 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0',
      },
    ],
  ]
);
